import { useState, useCallback, useEffect } from "react";

import { useAxios, APIError } from "../core/_axios";
import { Agency } from "../core/_models";
import { adminGetAgencies } from "../core/_requests";

export function useAgencies() {
    const axios = useAxios();

    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState<string | null>(null);
    const [agencies, setAgencies] = useState<Agency[]>([]);
    const [totalAgencies, setTotalAgencies] = useState<null | number>(null);

    const loadAgencies = useCallback(async () => {
        setLoading(true);
        setLoadingError(null);
        try {
            const {
                agencies: updatedAgencies,
                total_agencies: updatedTotalAgencies,
            } = await adminGetAgencies(axios);
            setTotalAgencies(updatedTotalAgencies);
            setAgencies(updatedAgencies);
        } catch (exception) {
            console.error(exception);
            const errorMessage = exception instanceof APIError
                ? exception.message
                : 'An unknown error has occurred. Please try again.';
            setLoadingError(errorMessage);
        } finally {
            setLoading(false);
        }
    }, [axios]);

    useEffect(() => {
        loadAgencies();
    }, [loadAgencies]);

    return {
        agencies,
        totalAgencies,
        loading,
        loadingError,
        reload: loadAgencies,
    };
}